import { useState } from "react";
import axiosInstanceMainUrl from "../utils/axiosInstanceMainUrl";

export default function useFilterHandler(url, filterData, setFilterData) {
  const [loader, setLoader] = useState();
  const [results, setResults] = useState([]);
  const [message, setmessage] = useState();
  const [error, setError] = useState(false);
  const [toastTrigger, setToastTrigger] = useState(0);

  // 🔹 API CALL
  // const apiCall = async (withParams = true) => {

  //   console.log("callling", url)
  //   setLoader(true)
  //   try {
  //     setLoader(true);

  //     let config = {};

  //     if (withParams) {
  //       config = {
  //         params: {
  //           ...filterData,
  //         },
  //       };
  //     }
  //     console.log('apicall ')
  //     const response = await axiosInstanceMainUrl.get(url, config);

  //     const { data, error,message } = response.data;

  //     if (!error) {
  //       setResults(data || []);
  //       setLoader(false)

  //     }else{

  //       setmessage(message)
  //     }
  //   } catch (err) {
  //     console.error("API ERROR:", err);

  //   } finally {
  //     setLoader(false);
  //   }
  // };
  //--------------------------------------------------------------------

  //   const validateAndSanitizeFilters = (filters) => {
  //   const params = {};
  //   let validationError = "";

  //   for (const [key, value] of Object.entries(filters)) {

  //     // Skip empty values
  //     if (value === "" || value === null || value === undefined) continue;

  //     const trimmedValue =
  //       typeof value === "string" ? value.trim() : value;

  //     switch (key) {
  //       case "phone":
  //         if (trimmedValue.length < 10) {
  //           validationError = "Phone must be at least 10 digits";
  //         } else {
  //           params[key] = trimmedValue;
  //         }
  //         break;

  //       case "name":
  //         if (trimmedValue.length < 3) {
  //           validationError = "Name must be at least 3 characters";
  //         } else {
  //           params[key] = trimmedValue;
  //         }
  //         break;

  //       case "panNo":
  //         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  //         if (!panRegex.test(trimmedValue.toUpperCase())) {
  //           validationError = "Invalid PAN format";
  //         } else {
  //           params[key] = trimmedValue.toUpperCase();
  //         }
  //         break;

  //       default:
  //         params[key] = trimmedValue;
  //     }

  //     // Stop at first validation error
  //     if (validationError) break;
  //   }

  //   return { params, validationError };
  // };
  const validateAndSanitizeFilters = (filters) => {
    const params = {};
    let errorMessage = "";

    const objectIdRegex = /^[a-fA-F0-9]{24}$/;
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]+$/i;
    const uuidRegexfromerchant =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    // const uuidRegexfromerchant = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    const phoneRegex = /^[0-9]{10}$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const alphaNumRegex = /^[a-zA-Z0-9]+$/;
    const bankRegex = /^[0-9]{9,18}$/;

    for (const [key, value] of Object.entries(filters)) {
      if (!value) continue; // skip empty

      const val = typeof value === "string" ? value.trim() : value;

      switch (key) {
        case "uniqueId":
          if (!uuidRegex.test(val)) {
            errorMessage = `${key} must be a valid UniqueId`;
          } else {
            params[key] = val;
          }
          break;

        case "customerRefNo":
          if (!objectIdRegex.test(val)) {
            errorMessage = `${key} must be valid ObjectId`;
          } else params[key] = val;
          break;

        case "phone":
          if (!phoneRegex.test(val)) {
            errorMessage = "Phone must be 10 digits";
          } else params[key] = val;
          break;

        case "panNo":
          if (!panRegex.test(val.toUpperCase())) {
            errorMessage = "Invalid PAN format";
          } else params[key] = val.toUpperCase();
          break;

        case "accountNo":
          if (!bankRegex.test(val)) {
            errorMessage = "Invalid Bank Account Number";
          } else params[key] = val;
          break;

        case "merchantTransactionId":
          // if (!uuidRegexfromerchant.test(val)) {
          //   errorMessage = "Invalid Merchant Transaction Id";
          // } else
          params[key] = val;
          break;

        case "orderId":
        case "pgorderId":
          if (val.length < 8) {
            errorMessage = `${key} must have valid length`;
          } else {
            params[key] = val;
          }
          break;

        case "quoteId":
        case "transactionId":

        case "invoiceId":
        case "mmtcRefNo":
          if (!alphaNumRegex.test(val)) {
            errorMessage = `${key} must be alphanumeric`;
          } else if (val.length < 8) {
            errorMessage = `${key} must have valid length`;
          } else {
            params[key] = val;
          }
          break;

        case "name":
          if (val.length < 3) {
            errorMessage = "Name must be at least 3 characters";
          } else params[key] = val;
          break;

        case "startDate":
        case "endDate":
          if (isNaN(new Date(val).getTime())) {
            errorMessage = `${key} is invalid date`;
          } else params[key] = val;
          break;

        case "status":
          const allowedStatus = ["SUCCESS", "FAILED", "PENDING"];
          if (!allowedStatus.includes(val)) {
            errorMessage = "Invalid status value";
          } else params[key] = val;
          break;

        case "metalType":
          const allowedMetal = ["gold", "silver"];
          if (!allowedMetal.includes(val.toLowerCase())) {
            errorMessage = "Invalid metal type";
          } else params[key] = val.toLowerCase();
          break;

        default:
          params[key] = val;
      }

      if (errorMessage) break;
    }

    // Date range validation
    if (!errorMessage && params.startDate && params.endDate) {
      if (new Date(params.startDate) > new Date(params.endDate)) {
        errorMessage = "Start date cannot be greater than End date";
      }
    }

    return { params, errorMessage };
  };

  const apiCall = async (withParams = true) => {
    setLoader(true);

    try {
      let config = {};

      if (withParams) {
        const { params, errorMessage } = validateAndSanitizeFilters(filterData);

        console.log("----------------------------pppp", params);

        if (errorMessage) {
          setError(true);
          setmessage(errorMessage);
          setLoader(false);
          return; //  STOP API CALL
        }

        config = { params };
      }

      const response = await axiosInstanceMainUrl.get(url, config);
      const { data, error, message } = response.data;

      if (!error) {
        setResults(data || []);
        setError(false);
        setmessage(message);
      } else {
        setError(true);
        setmessage(message || "Something went wrong");
      }
    } catch (err) {
      setError(true);
      setmessage(
        err?.response?.data?.message || err?.message || "Server error",
      );
    } finally {
      setLoader(false);

      setToastTrigger((prev) => prev + 1);
    }
  };

  //   const apiCall = async (withParams = true) => {
  //   console.log("calling", url);
  //   setLoader(true);

  //   try {
  //     let config = {};

  //     if (withParams) {
  //       config = {
  //         params: {
  //           ...filterData,
  //         },
  //       };
  //     }

  //     const response = await axiosInstanceMainUrl.get(url, config);

  //     const { data, error, message } = response.data;

  //     if (!error) {
  //       setResults(data || []);
  //       setError(false);
  //       setmessage(message)

  //     } else {
  //       setError(true);
  //       setmessage(message || "Something went wrong");
  //     }
  //   } catch (err) {
  //     console.error("API ERROR:", err);
  //       setError(true);
  //     setmessage(
  //       err?.response?.data?.message ||
  //       err?.message ||
  //       "Server error"
  //     );
  //   } finally {
  //     setLoader(false);
  //     console.log("-------oooooooooooooooooo",message)
  //   }
  // };

  // 🔹 SUBMIT
  const handleFilterSubmit = (e) => {
    // console.log("gggggggggg")
    e.preventDefault();
    apiCall(true);
  };

  // 🔹 CLEAR
  const handleClearFilters = () => {
    // console.log("ffffffffffffffff")
    setFilterData((prev) => {
      const cleared = {};

      Object.entries(prev).forEach(([key, value]) => {
        cleared[key] = typeof value === "boolean" ? false : "";
      });

      return cleared;
    });

    apiCall(false);
  };

  return {
    loader,
    results,
    error,
    message,
    toastTrigger,
    apiCall,
    handleFilterSubmit,
    handleClearFilters,
  };
}
